import React from "react";

import {
  TextCTA,
  GalleryGrid,
  GalleryCarousel,
  FooterContent,
  Media,
} from "components/GecoComponentRouter";

export const GecoComponentRouter = ({ components, lang }) => {
  return (
    <>
      {components.map((component) => {
        switch (component?.type) {
          case "text_cta":
            return (
              <TextCTA component={component} key={component.id} lang={lang} />
            );
          case "galleryGrid":
            return (
              <GalleryGrid
                component={component}
                key={component.id}
                lang={lang}
              />
            );
          case "galleryCarousel":
            return (
              <GalleryCarousel
                component={component}
                key={component.id}
                lang={lang}
              />
            );
          case "media":
            return (
              <Media component={component} key={component.id} lang={lang} />
            );
          case "FooterContent":
            return (
              <FooterContent
                component={component}
                key={component.id}
                lang={lang}
              />
            );
          default:
            return null;
        }
      })}
    </>
  );
};
